import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { arrowLocation } from '../svgIcons';

import { getStoresByUserLocation, getNearByStores, cleanDataStoreLocation } from '../../../../pages/NewHeader/actions';

class SearchByCurrentLocation extends Component {
  constructor(props) {
    super(props);
    this.initialState = {
      location: {
        lat: '',
        lng: '',
      },
      error: '',
    };

    this.state = { ...this.initialState };
  }

  getLocation = () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(this.showPosition);
    } else {
      this.setState({ ...this.state, error: 'Ha ocurrido un error, favor de intentar más tarde' });
    }
  };

  showPosition = (position) => {
    const lat = position.coords.latitude.toString();
    const lng = position.coords.longitude.toString();
    this.setState({ ...this.state, location: { ...this.state.location, lat, lng } }, () => {
      this.props.getStoresByUserLocation({ queryParam: this.state.location });
    });
  };

  render() {
    const { error } = this.state;
    const { zipCodeUserLoc } = this.props;

    const validateFailResponse = (errorResponse) => {
      if (!errorResponse) return errorResponse;
      return errorResponse && (zipCodeUserLoc.status === 'failure' || zipCodeUserLoc.statusCode === 404)
        && 'Ha ocurrido un error, favor de intentar más tarde.';
    };

    const getZipCodeLocation = (zipCodeUserLocData) => {
      const results = zipCodeUserLocData && Array.isArray(zipCodeUserLocData.results) && zipCodeUserLocData.results[0];
      const hasAddress = results && Array.isArray(results.address_components) && results.address_components;
      const searchZipCode = hasAddress[hasAddress.length - 1];
      const isZipCodeResult = searchZipCode && searchZipCode.types && searchZipCode.types.includes('postal_code');
      const zipCode = isZipCodeResult && searchZipCode.long_name;
      this.props.getNearByStores(zipCode);
    };

    const resultUserLocation = (zipCodeUserLoc && zipCodeUserLoc.status === 'OK')
      ? getZipCodeLocation(zipCodeUserLoc) : validateFailResponse(zipCodeUserLoc);

    return (
      <p className="searchByCurrentLocation alignmentRow" onClick={this.getLocation}>
        <span>{ arrowLocation }</span>
        { resultUserLocation || error || 'Buscar por mi ubicación actual' }
      </p>
    );
  }
}

const mapStateToProps = state => ({
  zipCodeUserLoc: state.storeLocation.zipCodeUserLoc,
});

const matchDispatchToProps = dispatch => bindActionCreators({
  getStoresByUserLocation,
  getNearByStores,
  cleanDataStoreLocation,
}, dispatch);

export default connect(mapStateToProps, matchDispatchToProps)(SearchByCurrentLocation);
